import React from 'react';
import { View, Button, TouchableOpacity,Image, ImageBackground, ScrollView, SafeAreaView } from 'react-native';
import { Surface, ActivityIndicator } from 'react-native-paper';
import { connect } from 'react-redux';
import {  getPrivacyAndPolicy, clearPrivacyAndPolicyData   } from './../../store/actions';
// import BackHandlerAndroid from './../AndroidBackHandler'; 
// import HTML from "react-native-render-html";
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import OfflineHandler from './../OfflineHandler';
import { Text, Styles } from "./../../components/UI-Components";
// import AdsScreen from './../Ads';
// import GestureRecognizer, {swipeDirections} from "./../UI-Components/gestureRecogniseComponent";
class PrivacyAndPolicyScreen extends React.Component{

    state={
       
    }


    componentDidMount(){
        this.props.getPrivacyAndPolicy();
    }
     

    onSwipeLeft = (gestureState) =>  {
        this.setState({myText: 'You swiped left!'});
      }
    
      onSwipeRight = (gestureState) => {
        this.setState({myText: 'You swiped right!'});
      }

      isAd = () => {
        this.setState({
          isAdShow: true
        })
      }

    render(){
        const config = {
            velocityThreshold: 0.4,
            directionalOffsetThreshold: 80
          };
        return(
            <div
      
            className='main-component'
          >
                
               

                        {!this.props._privacyAndPolicyData && <View style={{flex: 1, justifyContent:'center', alignItems: 'center'}}><ActivityIndicator/></View>}
                            <ScrollView
                               style={{
                                paddingHorizontal: 8,
                                textAlign: "justify",
                                paddingBottom: 50,
                                flex: 1,
                                marginBottom: 10,
                              }}
                            >
                                {/* <View style={{marginTop:10,marginHorizontal:15, paddingBottom: this.state.isAdShow ? 60 : 0}}> */}
                                    {
                                        this.props._privacyAndPolicyData && this.props._privacyAndPolicyData.length > 0 
                                        &&  
                                        // <HTML tagsStyles={{h3:{fontWeight:'700',marginVertical:5},p:{fontWeight:'400',marginVertical:2,textAlign:'justify'}}} html={ this.props._privacyAndPolicyData } />
                                        <div
                                        style={{ flex: 1 }}
                                        dangerouslySetInnerHTML={{
                                          __html: this.props._privacyAndPolicyData,
                                        }}
                                      ></div>
                                    }
                                    }
                                {/* </View> */}
                            </ScrollView>
                               
                                     
                {/* </View> */}
                {/* {
                    this.props._privacyAndPolicyData &&
                <AdsScreen screenName={'PrivacyAndPolicy'}  isAdCallBack={this.isAd}/>
                }  */}
             </div>
        )
    }
}

const mapStateToProps = state => ({
    loading: state.privacyAndPolicy && state.privacyAndPolicy.loading,
    error: state.privacyAndPolicy && state.privacyAndPolicy.error,
    errorInfo: state.privacyAndPolicy && state.privacyAndPolicy.error,
    _privacyAndPolicyData: state.privacyAndPolicy && state.privacyAndPolicy.response && state.privacyAndPolicy.response.Privacy_and_Policy
})

export default connect( mapStateToProps,{ getPrivacyAndPolicy, clearPrivacyAndPolicyData })(PrivacyAndPolicyScreen);

